import {
  CREATE_PRODUCT,
  CREATE_SUBMIT_PRODUCT,
  GET_PRODUCT,
  GET_PRODUCTS,
  GET_SUBMITTED_PRODUCTS,
  MERGE_PRODUCT,
  RESYNC_PRODUCT,
  UPDATE_PRODUCT,
} from "../actions/types";

export type Product = any;

export interface ProductState {
  productsLoading: boolean;
  products: Product[];
  submittedProductsLoading: boolean;
  submittedProducts: Product[];
  createdProduct: Product | null;
  createProductLoading: boolean;
  updatedProduct: Product | null;
  updateProductLoading: boolean;
  product: Product | null;
  createSubmitProductLoading: boolean;
  createdSubmitProduct: Product | null;
  productLoading: boolean;
  resyncProductLoading: boolean;
  mergeProduct: string;
  mergeProductLoading: boolean;
}

const defaultState = {
  productsLoading: false,
  products: [],
  productLoading: false,
  product: null,
  submittedProducts: [],
  submittedProductsLoading: false,
  createProductLoading: false,
  createdProduct: null,
  updateProductLoading: false,
  updatedProduct: null,
  createSubmitProductLoading: false,
  createdSubmitProduct: null,
  resyncProductLoading: false,
  mergeProduct: "",
  mergeProductLoading: false,
};

export const DefaultProductState = defaultState;

export type ProductAction = {
  type: string;
  productsLoading: boolean;
  productLoading: boolean;
  submittedProductsLoading: boolean;
  products: Product[];
  product: Product | null;
  submittedProducts: Product[];
  createdProduct: Product | null;
  createProductLoading: boolean;
  updatedProduct: Product | null;
  updateProductLoading: boolean;
  createSubmitProductLoading: boolean;
  createdSubmitProduct: Product | null;
  resyncProduct: string;
  resyncProductLoading: boolean;
  mergeProduct: string;
  mergeProductLoading: boolean;
};

export default (state: ProductState = defaultState, action: ProductAction) => {
  switch (action.type) {
    case GET_PRODUCTS:
      return {
        ...state,
        productsLoading: action.productsLoading,
        products: action.products,
      };
    case GET_SUBMITTED_PRODUCTS:
      return {
        ...state,
        submittedProductsLoading: action.submittedProductsLoading,
        submittedProducts: action.submittedProducts,
      };
    case CREATE_PRODUCT:
      return {
        ...state,
        createProductLoading: action.createProductLoading,
        createdProduct: action.createdProduct,
      };
    case GET_PRODUCT:
      return {
        ...state,
        productLoading: action.productLoading,
        product: action.product,
      };
    case UPDATE_PRODUCT:
      return {
        ...state,
        updateProductLoading: action.updateProductLoading,
        updatedProduct: action.updatedProduct,
      };
    case CREATE_SUBMIT_PRODUCT:
      return {
        ...state,
        createSubmitProductLoading: action.createSubmitProductLoading,
        createdSubmitProduct: action.createdSubmitProduct,
      };
    case RESYNC_PRODUCT:
      return {
        ...state,
        resyncProduct: action.resyncProduct,
        resyncProductLoading: action.resyncProductLoading,
      };
    case MERGE_PRODUCT:
      return {
        ...state,
        mergeProduct: action.mergeProduct,
        mergeProductLoading: action.mergeProductLoading,
      };
    default:
      return state;
  }
};
